import { FormEvent, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Navigate, useLocation, useNavigate } from "react-router";
import { ApiError, api } from "../../lib/api";
import "./auth.css";

type LoginLocationState = { from?: string };

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state || {}) as LoginLocationState;

  const me = useQuery({
    queryKey: ["auth", "me"],
    queryFn: api.me,
    retry: false,
    staleTime: 30_000,
  });

  const login = useMutation({
    mutationFn: () => api.login(email.trim(), password),
    onSuccess: (data) => {
      queryClient.setQueryData(["auth", "me"], data);
      navigate(state.from || "/rounds", { replace: true });
    },
  });

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!email.trim() || !password || login.isPending) return;
    login.mutate();
  };

  if (me.isSuccess) {
    return <Navigate to={state.from || "/rounds"} replace />;
  }

  const message = login.error instanceof ApiError
    ? login.error.message
    : login.error instanceof Error
      ? login.error.message
      : "";

  return (
    <main className="login-page">
      <section className="login-brand-panel">
        <div className="login-brand-mark">GS</div>
        <div>
          <span className="auth-kicker">GOLF SCORING OPERATIONS</span>
          <h1>Jedno miejsce do prowadzenia rundy.</h1>
          <p>Nowa wersja oddziela szybki interfejs operatorski od ciężkiego generowania i transportu.</p>
        </div>
        <div className="login-environment">
          <span>STAGING</span>
          <strong>v2-test.golfscoring.pl</strong>
        </div>
      </section>

      <section className="login-form-panel">
        <form className="login-card" onSubmit={submit}>
          <header>
            <span className="auth-kicker">STAGING V2</span>
            <h2>Zaloguj się</h2>
            <p>Użyj tego samego konta, którego używasz w obecnej aplikacji.</p>
          </header>

          <label>
            <span>E-mail</span>
            <input
              autoComplete="username"
              inputMode="email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="twoj@email.pl"
              required
            />
          </label>

          <label>
            <span>Hasło</span>
            <input
              autoComplete="current-password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="••••••••"
              required
            />
          </label>

          {message ? <div className="login-error" role="alert">{message}</div> : null}

          <button className="login-submit" type="submit" disabled={login.isPending}>
            {login.isPending ? "Logowanie…" : "Zaloguj się"}
          </button>

          <footer>
            <span>Sesja jest osobna od obecnej wersji v1.</span>
            <span>Połączenie HTTPS.</span>
          </footer>
        </form>
      </section>
    </main>
  );
}
